// for Angular there are cases where cg_init is called but element not yet in the DOM,
// this extra logic is necessary to find these elements.
export function findTargetForAngular(targetSelector, docElement) {
    var currentElement = docElement;
    while (currentElement.parentElement !== null) {
        currentElement = currentElement.parentElement;
        docElement = currentElement.querySelector(targetSelector);
        if (docElement)
            break;
    }
    return docElement;
}
